import { render, staticRenderFns } from "./bannerGovernmentShutdown.vue?vue&type=template&id=359b963c&"
import script from "./bannerGovernmentShutdown.vue?vue&type=script&lang=js&"
export * from "./bannerGovernmentShutdown.vue?vue&type=script&lang=js&"
import style0 from "./bannerGovernmentShutdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports